import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import { Observable } from "rxjs/Observable";
import { ConfigurationService } from "../configuration/configuration.service";

/*
  Generated class for the AnalyticsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnalyticsProvider {
  analyticsUrl: string;
  constructor(public http: HttpClient, private config: ConfigurationService) {
    this.analyticsUrl = config.getConfig().analyticsUrl;
  }

  public getAnalyticsURL(user: string): Observable<any> {
    let url = this.analyticsUrl + "?userName=" + user;

    return new Observable((observer) => {
      this.http.get(url).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts